// extracted by mini-css-extract-plugin
export default {"loader":"MyLoader_loader__-Oty1","rotate":"MyLoader_rotate__WAb6E"};